import styled from "styled-components";
import { appConfig } from "../appConfig";
import colors from "../common/colors";
import { fontSize, space } from "../common/variables";
import { getDeploymentSlot, getInjectedBuildId } from "../common/helpers/azureSlotRouting";

const StagingDeploymentBanner = () => {
    if (getDeploymentSlot() !== "staging") {
        return null;
    }

    const buildId = getInjectedBuildId() ?? appConfig.BUILD_ID;
    const label = buildId ? `Staging · build ${buildId}` : "Staging";

    return (
        <Banner role="status" aria-live="polite">
            {label}
        </Banner>
    );
};

export default StagingDeploymentBanner;

const Banner = styled.div`
    width: 100%;
    padding: ${space.xSmall} ${space.small};
    text-align: center;
    font-size: ${fontSize.small};
    font-weight: 700;
    color: ${colors.white};
    background-color: ${colors.red};
`;
